import * as React from "react";
import { observer, inject } from "mobx-react";
import { Button, TextField } from '@material-ui/core';

// =====================================
// STORES
import { ILoginStore } from '../../store/loginStore';

// =====================================
// COMPONENTS
import { Loader } from '../Layout/Loader';
import { ErrorMessage } from '../Layout/ErrorMessage';


interface IOrganization {
    loginStore?: ILoginStore;
}

@inject((allStores: any) => ({
    loginStore: allStores.store.loginStore as ILoginStore
}))

@observer
export default class Organization extends React.Component<IOrganization, any> {
    render() {
        return (
            <>
                <TextField
                    id="taxId"
                    label="PIB"
                    type="number"
                    name="taxId"
                    disabled={!this.props.loginStore.isSearchTaxIdVisible}
                    className="phone-number-input"
                    inputProps={{ maxLength: 9 }}
                    value={this.props.loginStore.taxId}
                    onChange={this.props.loginStore.onHandleChangeTaxId} />
                <ErrorMessage>
                    {this.props.loginStore.taxIdMessage}
                </ErrorMessage>
                {this.props.loginStore.isSearchTaxIdVisible
                    ? <>
                        <Button
                            variant="contained"
                            color="default"
                            size="small"
                            className="btn-login"
                            onClick={this.props.loginStore.searchTaxId}
                        > Pretrazi
                        </Button>
                    </> : null
                }
                { this.props.loginStore.isJoinOrganizationVisible
                    ? <>
                        <Button
                            variant="contained"
                            color="default"
                            size="small"
                            className="btn-login"
                            onClick={this.props.loginStore.registerAndJoinOrganization}
                            disabled={this.props.loginStore.isRegisterAndJoinOrganizationButtonDisabled}
                        > Registruj se/Pristupi organizaciji
                        </Button>
                        <Button
                            variant="contained"
                            color="default"
                            size="small"
                            className="btn-login"
                            onClick={this.props.loginStore.changeTaxId}
                        > Izmeni podatke
                        </Button>
                        <Button
                            variant="contained"
                            color="default"
                            size="small"
                            className="btn-login"
                            onClick={() => this.props.loginStore.onSignOut()}
                        > Otkazi
                        </Button>
                    </>
                    : null}
            </>
        );
    }
}